import Helper from '@ember/component/helper';

const WARNING_LABELS = {
  layout: 'Email layout was reset to default when copied.',
  segment_conditions: 'Segment conditions were removed when copied.',
  segment_multi_conditions: 'Segment conditions were removed when copied.',
  attribute_conditions: 'Attribute conditions were copied and should be reviewed.',
  attribute_multi_conditions: 'Attribute split conditions were copied and should be reviewed.',
  event_conditions_dropped: 'Event Data conditions were removed.',
  event_conditions_review: 'Event Data conditions were copied and should be reviewed.',
  webhook_conditions_dropped: 'Webhook Data conditions were removed.',
  webhook_conditions_review: 'Webhook Data conditions were copied and should be reviewed.',
  event_multi_conditions_dropped: 'Event Data split conditions were removed.',
  event_multi_conditions_review: 'Event Data split conditions were copied and should be reviewed.',
  webhook_multi_conditions_dropped: 'Webhook Data split conditions were removed.',
  webhook_multi_conditions_review: 'Webhook Data split conditions were copied and should be reviewed.',
  identities: 'From and Reply To addresses were reset to defaults when copied.',
  message_conditions: 'Message conditions were removed when copied.',
  message_multi_conditions: 'Message split conditions were removed when copied.',
  create_or_update_person_review: 'Create or Update Person content was copied and should be reviewed.',
  create_event_data_review: 'Send Event content was copied and should be reviewed.',
  create_event_data_dropped: 'Send Event content was modified and should be reviewed.',
  batch_update_data_review: 'Batch Update content was copied and should be reviewed.',
  batch_update_data_dropped: 'Batch Update content was modified and should be reviewed.',
  event_time_condition_review: 'Event time condition was copied and should be reviewed.',
  event_time_condition_dropped: 'Event time condition was removed when copied.',
  subscription_preferences_dropped: 'Subscription Preferences were reset to use campaign settings.',
};

export function copyWarningLabel(type) {
  return WARNING_LABELS[type] || '';
}

export default Helper.helper(copyWarningLabel);
